import { useEffect, useState } from 'react';
import { GiftOutlined, PlusOutlined, RightOutlined } from '@ant-design/icons';
import { Link } from 'react-router-dom';
import { Skeleton } from 'antd';
import { useTranslation } from 'react-i18next';
import { AppApc } from '../../../api/appApc';
import '../../Vouchers/Vouchers.css';
import {
    getVoucherAmount,
    getVoucherDate,
    getVoucherId,
    getVoucherLogo,
    getVoucherName,
    getVoucherRegion,
    type MyVoucher,
} from '../../Vouchers/mapVoucher';

function VoucherPanel() {
    const { t } = useTranslation('home');
    const [vouchers, setVouchers] = useState<MyVoucher[]>([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const listMyVoucher = async () => {
            try {
                const response = await AppApc.GetListMyVoucher();
                if (response.status === 200) {
                    setVouchers(Array.isArray(response?.data?.data) ? response.data.data : []);
                }
            } catch (error) {
                console.error('Error fetching list my voucher', error);
                setVouchers([]);
            } finally {
                setLoading(false);
            }
        };

        listMyVoucher();
    }, []);

    return (
        <section className="panel voucher-panel">
            <div className="section-head">
                <h2>{t('vouchers.title')}</h2>
                <Link className="text-button" to="/vouchers">
                    {t('actions.viewAll')}
                    <RightOutlined />
                </Link>
            </div>

            {loading ? (
                <div
                    className="voucher-panel__body voucher-panel__loading"
                    aria-busy="true"
                    aria-label={t('vouchers.loading')}
                >
                    {Array.from({ length: 2 }).map((_, index) => (
                        <div className="ticket-row" key={index}>
                            <Skeleton.Avatar active size={41} shape="square" />
                            <span className="label">
                                <Skeleton.Input active size="small" />
                            </span>
                        </div>
                    ))}
                </div>
            ) : vouchers.length ? (
                <div className="voucher-panel__body">
                    {vouchers.slice(0, 3).map((voucher) => {
                        const displayName = getVoucherName(voucher);
                        const logoUrl = getVoucherLogo(voucher);
                        const region = getVoucherRegion(voucher);
                        const amountLabel = getVoucherAmount(voucher);
                        const purchased = getVoucherDate(voucher);
                        const meta = [amountLabel, region, purchased].filter(Boolean).join(' · ');

                        return (
                            <Link
                                className="ticket-row"
                                to="/vouchers"
                                key={getVoucherId(voucher)}
                            >
                                <span
                                    className={`voucher-panel__logo${
                                        logoUrl ? ' voucher-panel__logo--image' : ''
                                    }`}
                                >
                                    {logoUrl ? <img src={logoUrl} alt="" /> : displayName.charAt(0)}
                                </span>
                                <span className="label">
                                    <strong>{displayName}</strong>
                                    <small>{meta}</small>
                                </span>
                                <RightOutlined />
                            </Link>
                        );
                    })}
                </div>
            ) : (
                <div className="voucher-panel__body vouchers-page__empty">
                    <GiftOutlined className="vouchers-page__empty-icon" />
                    <h3>{t('vouchers.emptyTitle')}</h3>
                    <p>{t('vouchers.emptyDescription')}</p>
                    <Link className="vouchers-page__browse" to="/explore">
                        <PlusOutlined />
                        {t('vouchers.browse')}
                    </Link>
                </div>
            )}
        </section>
    );
}

export default VoucherPanel;
